import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { courseDurationData } from '@/mocks/scheduleData';

const COURSE_COUNT = 3;

export default function CourseFlow() {
  const { t } = useTranslation();
  return (
    <section className="relative py-20 md:py-28 bg-background-100/50">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="text-center mb-12">
          {String(t('schedule.duration.structure')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">{__s}</p>))}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('schedule.duration.flowTitle')}
          </h2>
          {String(t('schedule.duration.titleEn')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="section-title-en text-accent-500 text-[15px] tracking-[0.12em] mb-4">{__s}</p>))}
          <div className="gold-line mx-auto"></div>
          {String(t('schedule.duration.flowDescription')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[15px] text-foreground-500 tracking-[0.04em] leading-relaxed max-w-[650px] mx-auto mt-5">{__s}</p>))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {Array.from({ length: COURSE_COUNT }, (_, idx) => (
            <Link
              key={idx}
              to={courseDurationData[idx].href}
              className="card-glow group block bg-background-50 border border-background-200/60 p-6 cursor-pointer"
            >
              <p className="text-[12px] text-accent-500 tracking-[0.12em] mb-3">{courseDurationData[idx].nameEn}</p>
              <h3 className="font-heading text-[17px] text-foreground-900 tracking-[0.05em] mb-4 group-hover:text-accent-600 transition-colors">
                {t(`schedule.duration.${idx}.name`)}
              </h3>
              <div className="space-y-2 mb-4">
                <div className="flex items-baseline justify-between">
                  <span className="text-[13px] text-foreground-500 tracking-[0.04em]">{t('schedule.duration.col.days')}</span>
                  <span className="text-[14px] text-foreground-800 tracking-[0.04em]">{t(`schedule.duration.${idx}.days`)}</span>
                </div>
                <div className="flex items-baseline justify-between">
                  <span className="text-[13px] text-foreground-500 tracking-[0.04em]">{t('schedule.duration.col.hours')}</span>
                  <span className="text-[14px] text-foreground-800 tracking-[0.04em]">{t(`schedule.duration.${idx}.hours`)}</span>
                </div>
                <div className="flex items-baseline justify-between">
                  <span className="text-[13px] text-foreground-500 tracking-[0.04em]">{t('schedule.duration.col.weeks')}</span>
                  <span className="text-[14px] text-foreground-800 tracking-[0.04em]">{t(`schedule.duration.${idx}.weeks`)}</span>
                </div>
                <div className="flex items-baseline justify-between pt-2 border-t border-background-200/60">
                  <span className="text-[13px] text-foreground-500 tracking-[0.04em]">{t('schedule.duration.col.schedule')}</span>
                  <span className="text-[14px] text-accent-600 tracking-[0.04em]">{t(`schedule.duration.${idx}.schedule`)}</span>
                </div>
              </div>
              <div className="flex items-center gap-2 text-accent-500 group-hover:text-accent-400 transition-colors">
                <span className="text-[13px] tracking-[0.06em]">{t('schedule.duration.viewLink')}</span>
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-xs"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}